import { Fragment, useEffect, useState } from "react";
import "../../assets/styles/dashboard/dashboard.scss";
import { useNavigate } from "react-router-dom";
//@ts-ignore
import persianDate from "persian-date";
import { useDispatch, useSelector } from "react-redux";
import { Button, Container, styled, useTheme } from "@mui/material";
import { apiGetBusinessCurrencies, apiGetCurrencies } from "../../api/currencyApi";
import { appSetModal } from "store/actions/appAction";
import Typography from "@mui/material/Typography";
import { apiGetFiscalYears } from "../../api/appApi";
import { useAppDispatch, useAppSelector } from "store/store";
import BasicButton from "components/BasicInputs/BasicButton";

const moment = require("moment-jalaali");

const DashboardHeader = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

interface checkScrolled {
  scrolled?: boolean;
}

const MobileDashboardHeader = styled("div")<checkScrolled>(({ theme, scrolled }) => ({
  display: "none",
  height: scrolled ? "60px" : "128px",
  boxShadow: "unset",
  width: "100vw",
  position: "fixed",
  zIndex: 10,
  transition: "all 0.3s ease",
  padding: "16px",
  backgroundColor: "#FBFBFF",
  [theme.breakpoints.down("md")]: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
}));
const MobileDashboardHeaderSpacer = styled("div")<checkScrolled>(({ theme, scrolled }) => ({
  display: "none",
  height: scrolled ? "60px" : "128px",
  transition: "all 0.3s ease",
  boxShadow: "unset",
  width: "100vw",
  justifyContent: "space-between",
  [theme.breakpoints.down("md")]: {
    display: "flex",
    flexDirection: "column",
  },
}));

const TopItemContainer = styled("div")(({ theme }) => ({
  display: "flex",
  width: "100%",
  margin: "5px",
  justifyContent: "space-between",
}));
const CompanyNameContainer = styled("div")(({ theme }) => ({
  display: "flex",
}));

const DashboardLayout = ({ children, hideEditButton }: ChildrenPropType) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const store = useAppSelector((state: any) => state);
  const business = store.businessReducer.business;
  const token = store.appReducer.token;
  const today = new persianDate().format("dddd, DD MMMM");
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    business && dispatch(apiGetBusinessCurrencies(business.token));
    business && dispatch(apiGetFiscalYears());
    dispatch(apiGetCurrencies(token));
  }, [token]);

  useEffect(() => {
    if (!window) return;
    window.addEventListener("scroll", () => {
      if (window.scrollY > 10 && !scrolled) {
        setScrolled(true);
      }
      if (window.scrollY < 10 && scrolled) {
        setScrolled(false);
      }
    });
  }, []);

  const displaySubscription = () => {
    const now = new Date();
    const date = moment(business?.business?.expirationAt, "jYYYY/jM/jD").format("YYYY-M-D");
    const difference = Math.floor((Date.parse(date) - Date.parse(now as unknown as string)) / 86400000);
    return (
      <Fragment>
        {
        //   business?.business?.subscriptionTitle === "بی نهایت" ? (
        //   <>
        //     <span style={{ color: "#747575", fontWeight: "normal" }}>
        //       چرتکه {business?.business?.subscriptionTitle}
        //     </span>
        //   </>
        // ) :
          (
          <>
            <span style={{ color: "#1062D0", fontWeight: "bold" }}>{difference}</span> روز مانده از پشتیبانی شما{" "}
            {/*{business?.business?.subscriptionTitle}*/}
          </>
        )}
      </Fragment>
    );
  };

  return (
    <>
      <MobileDashboardHeader scrolled={scrolled}>
        {!scrolled && (
          <TopItemContainer>
            <div>{today}</div>
            <div>{displaySubscription()}</div>
          </TopItemContainer>
        )}
        <TopItemContainer>
          <CompanyNameContainer>
            <Typography variant="h6">داشبورد حسابداری</Typography>
            <Typography variant="h6" color="primary">
              &nbsp;{business?.business?.nickName}
            </Typography>
          </CompanyNameContainer>
        </TopItemContainer>
      </MobileDashboardHeader>
      <MobileDashboardHeaderSpacer scrolled={scrolled} />
      <Container maxWidth="xl">
        <div className="wrap-dashboard">
          <DashboardHeader className="wrap-header-dashboard-page">
            <div className="date-dashboard-page d-flex justify-content-between">
              <div>{today}</div>
              <div className="day-dashboard">{displaySubscription()}</div>
            </div>
            <div className="wrap-welcome-dashboard">
              <div className="wrap-welcome-chortke">
                داشبورد حسابداری <span>{business?.business?.nickName}</span>
              </div>
              {business?.business?.subscriptionTitle === "بی نهایت" ? null : (
                <div className="buy-subscription" onClick={() => navigate("/business/extend")}>
                  خرید اشتراک
                </div>
              )}
            </div>
            <div
              className="box-desc-dashboard"
              // onClick={() => navigate('/business/extend')}
            >
              <div className="desc-header-dashboard">
                کاربر سیستم: {`${business?.user?.firstName} ${business?.user?.lastName}`}
              </div>
              {hideEditButton ? null : (
                <DashboardHeader
                  style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end" }}
                >
                  <BasicButton
                    variant="outlined"
                    color="disabled"
                    onClick={() =>
                      dispatch(
                        appSetModal(
                          { component: "add-widget", title: "افزودن ویجت", closeButton: true },
                          true
                        )
                      )
                    }
                  >
                    افزونه ها
                  </BasicButton>
                </DashboardHeader>
              )}
            </div>
          </DashboardHeader>

          <div className="w-full  my-10 md:hidden  sm:flex xs:flex">
            <p
              className="w-[124px]  h-[40px]  rounded-md      border border-solid mr-auto "
              onClick={() =>
                dispatch(
                  appSetModal({ component: "add-widget", title: "افزودن ویجت", closeButton: true }, true)
                )
              }
            >
              <span className="w-full h-full  flex justify-center items-center  ">افزونه ها</span>
            </p>
          </div>
          <div className="wrap-content-dashboard-page">{children}</div>
        </div>
      </Container>
    </>
  );
};

export default DashboardLayout;
